import ContactDetailsContainer from './ContactDetailsContainer';
export default ContactDetailsContainer;
